import { useCallback, useContext, useMemo } from 'react'
import AuthContext from '../../context/authContext'
import { AuthService } from '../../lib/api'
import { resolveReturnToForLogin } from '../../lib/utils/authRedirect'
import { AuthLogoutUrlOptions } from '../../lib/api/types/auth.interfaces'

export const useAuth = () => {
	const {
		currentUser,
		setCurrentUser,
		mfaEnabled,
		setMfaEnabled,
		isAuthenticated,
		isAuthLoading,
		setIsAuthLoading,
	} = useContext(AuthContext)

	const isAdmin = Boolean(currentUser?.organization?.isAdministrator)
	const isOwner = Boolean(currentUser?.organization?.isOwner)

	const login = useCallback((provider: 'auth0' | 'azure' = 'auth0') => {
		if (provider === 'azure') {
			window.location.href = `${process.env.REACT_APP_NODE_BACKEND_API}/2/ad/login`
			return
		}

		const returnTo = resolveReturnToForLogin(window.location.href)
		AuthService.login({ returnTo })
	}, [])

	const logout = useCallback(
		(_options?: AuthLogoutUrlOptions) => {
			setCurrentUser(null)
			setMfaEnabled(false)
			AuthService.logout()
		},
		[setCurrentUser, setMfaEnabled],
	)

	return useMemo(
		() => ({
			currentUser,
			setCurrentUser,
			mfaEnabled,
			setMfaEnabled,
			isAuthenticated,
			isAuthLoading,
			loading: isAuthLoading,
			setIsAuthLoading,
			isAdmin,
			isOwner,
			login,
			logout,
		}),
		[
			currentUser,
			isAdmin,
			isAuthenticated,
			isAuthLoading,
			isOwner,
			login,
			logout,
			mfaEnabled,
			setCurrentUser,
			setIsAuthLoading,
			setMfaEnabled,
		],
	)
}
